import { render, staticRenderFns } from "./ChamadoPrioridade.vue?vue&type=template&id=3e4b980b&"
import script from "./ChamadoPrioridade.vue?vue&type=script&lang=js&"
export * from "./ChamadoPrioridade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports